/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TreeModule } from 'angular-tree-component';
import { TreeDropTargetDirective } from './dnd/tree-drop-target.directive';
import { TreeDropDirective } from './dnd/tree-drop.directive';
import { TreeNodeDndDropSlotComponent } from './dnd/tree-node-dnd-drop-slot.component';
import { TreeNodeDndWrapperComponent } from './dnd/tree-node-dnd-wrapper.component';
import { TreeNodeDndComponent } from './dnd/tree-node-dnd.component';
import { TreeNodeDndPointerComponent } from './tree-node-dnd-pointer.component';
import { TreeNodeWrapperComponent } from './tree-node-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TreeModule.forRoot(),
  ],
  declarations: [
    TreeNodeDndPointerComponent,
    TreeNodeWrapperComponent,
    TreeNodeDndComponent,
    TreeNodeDndWrapperComponent,
    TreeNodeDndDropSlotComponent,
    TreeDropDirective,
    TreeDropTargetDirective,
  ],
  exports: [
    TreeNodeDndPointerComponent,
    TreeNodeWrapperComponent,
    TreeNodeDndComponent,
    TreeNodeDndWrapperComponent,
    TreeNodeDndDropSlotComponent,
    TreeDropTargetDirective,

    TreeModule,
  ],
})
export class CoreUiExtTreeModule {
}
